import { __decorate, __metadata } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { BrMaskerModule } from 'br-mask';
import { TooltipModule } from 'ng2-tooltip-directive';
import { NgxMaskIonicModule } from 'ngx-mask-ionic';

let UiCListDebitsDetranComponent = class UiCListDebitsDetranComponent {
    constructor() {
        this.emitValue = new EventEmitter();
        this.emitList = new EventEmitter();
        this.disabledItem = false;
        this.value = 0;
        this.year = new Date().getFullYear().toString();
        this.disabledItensSelected = true;
    }
    ngOnInit() {
        this.listItemSell = [];
        setTimeout(() => {
            this.verifyTypeOperation();
        }, 200);
    }
    onChangeForm() {
    }
    checkedItem(item, event, index) {
        this.itemSelected = item;
        let existsInArray = this.listItemSell.find(el => {
            return el.title === item.title && el.value === item.value;
        });
        if (existsInArray == undefined) {
            this.verifyItemSelected(item);
            this.listItemSell.push(item);
            this.value += item.value;
            this.emitValue.emit(this.value);
            this.emitList.emit(this.listItemSell);
        }
        else {
            this.removeItemArray();
            if (this.year === item.title) {
                this.dataResult.debits[0].data.forEach((el, index) => {
                    if (el.title === this.year) {
                        this.dataResult.debits[0].data[index].disabled = false;
                    }
                });
            }
        }
    }
    removeItemArray() {
        for (let index = 0; index < this.listItemSell.length; index++) {
            if (this.listItemSell[index].title === this.itemSelected.title && this.listItemSell[index].value === this.itemSelected.value) {
                this.value -= this.listItemSell[index].value;
                this.emitValue.emit(this.value);
                this.listItemSell.splice(index, 1);
            }
        }
    }
    verifyItemSelected(selected) {
        if (this.dataResult.service === "IPVA") {
            if (selected.title === this.year) {
                this.dataResult.debits[0].data.forEach((el, index) => {
                    if (el.title === this.year && selected.value != el.value) {
                        this.dataResult.debits[0].data[index].disabled = true;
                    }
                });
            }
        }
    }
    verifyTypeOperation() {
        if (this.dataResult.service === "Licenciamento") {
            this.disabledItensSelected = false;
        }
    }
};
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCListDebitsDetranComponent.prototype, "dataResult", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCListDebitsDetranComponent.prototype, "emitValue", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCListDebitsDetranComponent.prototype, "emitList", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCListDebitsDetranComponent.prototype, "disabledItensSelected", void 0);
UiCListDebitsDetranComponent = __decorate([
    Component({
        selector: 'ui-c-list-debits-detran',
        template: "<div class=\"consult-debits-detran\">\n  <ng-container *ngIf=\"dataResult?.vehicleOwner != null\">\n\n    <h4 class=\"ion-text-center title\">{{'CASH_OUT.DETRAN.TEXT.DATA_VEHICLE'| wlpTranslate}}</h4>\n    <ion-item lines=\"none\">\n      <ion-label>\n        <p>\n          <span>{{'CASH_OUT.DETRAN.LABELS.VEHICLE_OWNER'| wlpTranslate}}</span>\n          {{dataResult?.vehicleOwner}}\n        </p>\n        <p>\n          <span>{{'CASH_OUT.DETRAN.LABELS.RENAVAM'| wlpTranslate}} </span>\n          {{dataResult?.vehicleRenavam}}\n        </p>\n        <p>\n          <span>{{'CASH_OUT.DETRAN.LABELS.PLATE'| wlpTranslate}} </span>\n          {{dataResult?.vehiclePlate}}\n        </p>\n        <p>\n          <span>{{'CASH_OUT.DETRAN.LABELS.UF'| wlpTranslate}} </span>\n          {{dataResult?.vehicleUf}}\n        </p>\n        <p>\n          <span>{{'CASH_OUT.DETRAN.LABELS.CITY'| wlpTranslate}} </span>\n          {{dataResult?.vehicleCity}}\n        </p>\n      </ion-label>\n    </ion-item>\n\n  </ng-container>\n  <ion-list>\n    <ng-container *ngFor=\"let item of dataResult?.debits;\">\n      <ion-item-divider>\n        <h4 class=\"bold\"> {{item.title}} </h4>\n      </ion-item-divider>\n\n      <ion-item lines=\"full\" *ngFor=\"let data of item?.data;let i = index\">\n        <ion-checkbox *ngIf=\"disabledItensSelected\" [disabled]=\"data?.disabled\"\n          (ionChange)=\"checkedItem(data, $event, i)\" mode=\"ios\" slot=\"start\" color=\"primary\"></ion-checkbox>\n        <ion-label>\n          <p *ngIf=\"data?.title\">{{'CASH_OUT.DETRAN.LABELS.TYPE'| wlpTranslate}} {{ data?.title }}</p>\n          <p *ngIf=\"data?.description\">{{'CASH_OUT.DETRAN.LABELS.DESCRIPTION'| wlpTranslate}} {{ data?.description }}\n          </p>\n          <p *ngIf=\"data?.value\">{{'CASH_OUT.DETRAN.LABELS.VALUE'| wlpTranslate}} {{ data?.value |\n            currency:'BRL':'symbol':'0.2':'pt' }}</p>\n          <p *ngIf=\"data?.dueDate\">{{'CASH_OUT.DETRAN.LABELS.DATE'| wlpTranslate}} {{ data?.dueDate | date: 'dd/MM/yyyy'\n            }}</p>\n        </ion-label>\n      </ion-item>\n    </ng-container>\n  </ion-list>\n</div>",
        styles: [""]
    }),
    __metadata("design:paramtypes", [])
], UiCListDebitsDetranComponent);

let UiCListDebitsDetranComponentModule = class UiCListDebitsDetranComponentModule {
};
UiCListDebitsDetranComponentModule = __decorate([
    NgModule({
        declarations: [UiCListDebitsDetranComponent],
        imports: [
            CommonModule,
            IonicModule,
            ReactiveFormsModule,
            TooltipModule,
            BrMaskerModule,
            NgxMaskIonicModule,
            UiBsTranslateModule,
        ],
        exports: [UiCListDebitsDetranComponent]
    })
], UiCListDebitsDetranComponentModule);

export { UiCListDebitsDetranComponent, UiCListDebitsDetranComponentModule };
//# sourceMappingURL=wlp-ui-c-list-debits-detran.js.map
